import React, { createContext, useContext, ReactNode, useReducer } from "react";
import { IGuestCuratorRecord } from "@src/types/curator";
// import { IShow } from '@src/types/show';

interface CuratorInformationContextState {
  myGuestCurators: IGuestCuratorRecord[];
  // myAssignedShows: IShow[];
  myAssignedShows: unknown[];
  setMyGuestCurators: (payload: IGuestCuratorRecord[]) => void;
  setMyAssignedShows: (payload: unknown[]) => void;
}
type CuratorInformationAction =
  | {
      type: "SET_MY_GUEST_CURATORS";
      payload: IGuestCuratorRecord[];
    }
  | {
      type: "SET_MY_ASSIGNED_SHOWS";
      payload: unknown[];
    };

const initialCuratorInformationState: CuratorInformationContextState = {
  myGuestCurators: [],
  myAssignedShows: [],
  setMyGuestCurators: () => {},
  setMyAssignedShows: () => {},
};

const CuratorInformationContext = createContext<
  CuratorInformationContextState | undefined
>(initialCuratorInformationState);

const curatorInformationReducer = (
  state: CuratorInformationContextState,
  action: CuratorInformationAction
): CuratorInformationContextState => {
  switch (action.type) {
    case "SET_MY_GUEST_CURATORS":
      return {
        ...state,
        myGuestCurators: action.payload,
      };
    case "SET_MY_ASSIGNED_SHOWS":
      return {
        ...state,
        myAssignedShows: action.payload,
      };
    default:
      return state;
  }
};
export const CuratorInformationProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [state, dispatch] = useReducer(
    curatorInformationReducer,
    initialCuratorInformationState
  );

  const setMyGuestCurators = (payload: IGuestCuratorRecord[]): void => {
    dispatch({ type: "SET_MY_GUEST_CURATORS", payload });
  };
  const setMyAssignedShows = (payload: unknown[]): void => {
    dispatch({ type: "SET_MY_ASSIGNED_SHOWS", payload });
  };
  return (
    <CuratorInformationContext.Provider
      value={{ ...state, setMyGuestCurators, setMyAssignedShows }}
    >
      {children}
    </CuratorInformationContext.Provider>
  );
};

export const useCuratorInformation = (): CuratorInformationContextState => {
  const context = useContext(CuratorInformationContext);
  if (!context) {
    throw new Error(
      "useCuratorInformation must be used within a CuratorInformationProvider"
    );
  }
  return context;
};
